import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFreshsalesLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7093 2H22.5179C24.1628 2 25.483 3.29856 25.483 4.96505V13.7736C25.483 20.2448 20.2454 25.4824 13.7742 25.4824H13.7093C7.23814 25.4824 2.0006 20.2448 2.0006 13.7736C1.93567 7.30247 7.17321 2.06493 13.6444 2H13.7093Z",
			fill: "#FFA800"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8602 7.86328C15.1588 7.86328 16.1976 8.90214 16.1976 10.2007C16.1976 11.4993 15.1588 12.5381 13.8602 12.5381C12.5616 12.5381 11.5228 11.4993 11.5228 10.2007C11.5011 8.90214 12.5616 7.86328 13.8602 7.86328Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.6875 13.2969L12.7563 17.3657V19.6382H14.7475V17.3657L18.8163 13.2969H8.6875Z",
			fill: "white"
		})
	]
});
export default SvgFreshsalesLogo;
